<template>
  <div class="checkbox">
    <label :data-cy="`${dataCy}-label`">
      <input
        type="checkbox"
        name="optionsCheckboxes"
        v-on:input="$emit('change', $event.target.checked)"
        :disabled="disabled"
        v-model="content"
        :data-cy="dataCy"
      />
      <span  :key="reRender" class="checkbox-material">
        <span class="check"></span>
      </span>
      <span v-html="label" class="dark-color"></span>
    </label>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "SCheckbox",
  props: ["label", "disabled", "input", "dataCy"],
  model: {
    prop: "input",
    event: "change"
  },
  data() {
    return {
      content: this.input,
      reRender: 0
    };
  },
  methods: {
    reRenderer() {
      this.reRender += 1;
    }
  },
  watch: {
    input: function(newValue) {
      if (newValue !== this.content) {
        this.content = newValue;
      }
    }
  },
  mounted() {
    this.reRenderer();
  }
};
</script>

<style scoped>
.check {
  border-color: #515365 !important;
}

.dark-color {
  color: #515365 !important;
  font-size: 0.875rem !important;
}
</style>
